export function isDefined(obj: any): boolean {
  return obj !== undefined && obj !== null;
}

export function notDefined(obj: any): boolean {
  return obj === undefined || obj === null;
}

export function isNotEmpty(obj: string): boolean {
  return obj !== undefined && obj !== null && obj.trim().length > 0;
}

export function arrayNotEmpty(obj: Array<any>): boolean {
  return obj !== undefined && obj !== null && obj.length > 0;
}

export function arrayIsEmpty(obj: Array<any>): boolean {
  return obj === undefined || obj === null || obj.length === 0;
}

export function isObject(val: any): boolean {
  return val instanceof Object;
}

export function copyObj<T>(obj: T): T {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj;
}

export function isObjEmpty(obj: any) {
  return Object.keys(obj || {}).length === 0;
}

export function getKeyByValue(enumObject: any, value: string): string {
  return Object.keys(enumObject).find((key) => enumObject[key] === value);
}

export function isDateInFuture(date: Date | string): boolean {
  return new Date(date).getTime() > Date.now();
}
